import { useEffect, useRef } from 'react';
import { ADS, type AdSlotName, adsEnabled } from '@/config/ads';

declare global {
  interface Window {
    adsbygoogle?: unknown[];
  }
}

/**
 * 애드센스 디스플레이 광고 영역.
 * 게시자 ID나 슬롯 ID가 비어 있으면 아무것도 렌더링하지 않아 레이아웃에 영향을 주지 않습니다.
 * 게임 진행 화면(선택 중)에는 넣지 않습니다. 실수로 광고를 누르는 것을 막기 위해서입니다.
 */
export function AdSlot({ name }: { name: AdSlotName }) {
  const slot = ADS.slots[name];
  const ref = useRef<HTMLModElement>(null);
  const pushed = useRef(false);

  useEffect(() => {
    if (!adsEnabled() || !slot || pushed.current) return;
    try {
      (window.adsbygoogle = window.adsbygoogle ?? []).push({});
      pushed.current = true;
    } catch {
      /* 광고 차단기 등 */
    }
  }, [slot]);

  if (!adsEnabled() || !slot) return null;

  return (
    <div className="my-2 w-full overflow-hidden text-center" aria-label="광고">
      <ins
        ref={ref}
        className="adsbygoogle block"
        style={{ display: 'block' }}
        data-ad-client={ADS.client}
        data-ad-slot={slot}
        data-ad-format="auto"
        data-full-width-responsive="true"
      />
    </div>
  );
}
